import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import {
	GetApp as Download2Icon,
	Delete as DeleteIcon,
	KeyboardArrowUp as KeyboardArrowUpIcon,
	KeyboardArrowDown as KeyboardArrowDownIcon,
} from '@material-ui/icons';
import { toast } from 'react-toastify';

import LoadingCenter from '../../../Components/LoadingCenter';
import DateTimeLabel from '../../../Components/DateTimeLabel';
import ConfirmModal from '../../../Components/ConfirmModal';

import APIGet from '../../../API/APIGet';
import APIHelper from '../../../Helper/APIHelper';
import AppConfig from '../../../AppConfig';

import OpenLink from '../../../Helper/OpenLink';
import TravelerHelper from '../../../Helper/Traveler';

export default class Traveler extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			traveler: null,
			isLoading: false,
			deleteConfirmId: null,
			isReordering: false,
		};
		// react-select clears the input on blur; AsyncSelect then drops in-flight loadOptions
		// (lastRequest cleared), so results for e.g. "99" never apply. Keep last search on blur.
		this._lastTravelerSearchInput = '';
	}

	onGetRoomingList = () => {
		const { programId } = this.props;
		OpenLink.getRoomingList(programId);
	};

	onGetInsuranceList = () => {
		const { programId } = this.props;
		OpenLink.getInsuranceList(programId);
	};

	travelerSelectOnInputChange = (newValue, actionMeta) => {
		if (actionMeta.action === 'input-blur') {
			return this._lastTravelerSearchInput;
		}
		this._lastTravelerSearchInput = newValue || '';
		return newValue;
	};

	loadTravelerOptions = async inputValue => {
		const { travelers, initTravelers } = this.props;
		const q = (inputValue || '').trim();
		// When empty input, show the preloaded options (already filtered to exclude existing travelers).
		if (!q) return initTravelers || [];
		const request = await APIGet('travelers?page=1&perPage=40&filter=' + q);
		if (!APIHelper.handleAPIResponse(this, request)) {
			toast.error('ไม่สามารถดึงข้อมูล Traveler ได้ กรุณาลองใหม่อีกครั้ง');
			return [];
		}

		const responseData = request.data;

		const apiTravelers = Array.isArray(responseData) ? responseData : responseData.data || [];
		const existingTravelerIds = new Set((travelers || []).map(t => t.id));
		return apiTravelers
			.filter(t => t && !existingTravelerIds.has(t.id))
			.map(t => ({
				value: t.id,
				label: TravelerHelper.getNameAndContact(t),
			}));
	};

	addTraveler = async () => {
		// console.log('addTraveler', this.state.traveler);
		if (this.state.traveler) {
			this._lastTravelerSearchInput = '';
			this.setState({
				traveler: null,
			});
			if (this.props.onAddTraveler) {
				this.props.onAddTraveler(this.state.traveler);
			}
		}
	};

	deleteTraveler = async travelerId => {
		// console.log('deleteTraveler', travelerId);
		if (travelerId) {
			this.setState({ deleteConfirmId: null });
			if (this.props.onDeleteTraveler) {
				this.props.onDeleteTraveler(travelerId);
			}
		}
	};

	moveTraveler = async (index, delta) => {
		const { travelers } = this.props;
		if (!travelers || travelers.length < 2 || this.state.isReordering) return;
		const newIndex = index + delta;
		if (newIndex < 0 || newIndex >= travelers.length) return;
		const next = [...travelers];
		const tmp = next[index];
		next[index] = next[newIndex];
		next[newIndex] = tmp;
		const travelerIds = next.map(t => t.id);
		this.setState({ isReordering: true });
		try {
			console.log('new traveler ids: ', travelerIds);
			if (this.props.onRearrangeTravelers) {
				await this.props.onRearrangeTravelers(travelerIds);
			}
		} finally {
			this.setState({ isReordering: false });
		}
	};

	render() {
		const { travelers, initTravelers } = this.props;
		if (this.state.isLoading) {
			return <LoadingCenter />;
		}
		const getTravelerLabel = option => {
			if (!option) return '';
			// react-select option shape: { value, label }
			if (typeof option.label === 'string') return option.label;
			return TravelerHelper.getNameAndContact(option);
		};

		// When this string changes, AsyncSelect clears optionsCache (react-select v3).
		// Otherwise the same search reuses stale options and shows travelers already on the program.
		const travelerOptionsCacheKey = (travelers || []).map(t => t.id).join(',');

		return (
			<div className="section">
				<div className="columns">
					<div className="column is-6">
						<h3 className="title is-3">Traveler </h3>
					</div>
				</div>
				<div className="columns">
					<div className="column is-8">
						<div className="columns">
							<div className="column is-9">
								<AsyncSelect
									name="traveler"
									value={this.state.traveler}
									clearable={false}
									onChange={value => {
										this._lastTravelerSearchInput = '';
										this.setState({ traveler: value });
									}}
									onInputChange={this.travelerSelectOnInputChange}
									defaultOptions={initTravelers}
									cacheOptions={travelerOptionsCacheKey}
									loadOptions={this.loadTravelerOptions}
									getOptionValue={option => option && option.value}
									getOptionLabel={getTravelerLabel}
									loadingMessage={() => 'กำลังค้นหา...'}
									placeholder="ค้นหาจากชื่อ, เบอร์โทร, email"
									noOptionsMessage={() => 'ไม่มีข้อมูล Travel'}
								/>
							</div>
							<div className="column is-3">
								<button className="button is-success" onClick={this.addTraveler}>
									เพิ่ม Traveler
								</button>
							</div>
						</div>
					</div>
					<div className="column is-4" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', flexWrap: 'wrap', gap: 12 }}>
						<button className="button is-info" onClick={this.onGetInsuranceList}>
							<Download2Icon style={{ fontSize: 20, color: 'white' }} />
							Insurance list
						</button>
						<button
							className="button is-info"
							style={{
								backgroundColor: '#ff6e12',
							}}
							onClick={this.onGetRoomingList}
						>
							<Download2Icon style={{ fontSize: 20, color: 'white' }} />
							Rooming list
						</button>
					</div>
				</div>
				<div className="table-container">
					<table className="table is-hoverable is-fullwidth is-striped is-bordered">
						<thead>
							<tr className="table-header">
								<td width="30%">ชื่อ-นามสกุล</td>
								<td width="10%">เลขบัตรประชาชน</td>
								<td width="5%">อายุ</td>
								<td width="10%">เบอร์โทร</td>
								<td width="15%">email</td>
								<td width="15%">LINE</td>
								<td width="15%">สร้างเมื่อ</td>
								<td width="8%">จัดลำดับ</td>
								<td width="5%" />
							</tr>
						</thead>
						<tbody>
							{travelers.map((data, index) => {
								return (
									<tr key={data.id}>
										<td>
											<Link to={AppConfig.appPath + '/travelers/' + data.id} style={TravelerHelper.fullNameStyle}>
												{TravelerHelper.getFullName(data)}
											</Link>
										</td>
										<td style={{ textAlign: 'center' }}>{data.idCardNumber ? data.idCardNumber : '-'}</td>
										<td style={{ textAlign: 'center' }}>{data.age ? data.age : '-'}</td>
										<td style={{ textAlign: 'center' }}>{data.telephone ? data.telephone : '-'}</td>
										<td style={{ textAlign: 'center' }}>{data.email ? data.email : '-'}</td>
										<td style={{ textAlign: 'center' }}>{data.line ? data.line : '-'}</td>
										<td style={{ textAlign: 'center' }}>
											<DateTimeLabel date={data.createdAt} />
										</td>
										<td style={{ textAlign: 'center', whiteSpace: 'nowrap' }}>
											{index === 0 ? null : (
												<button
													type="button"
													className="button is-small is-text"
													style={{ padding: 4, minWidth: 'auto', verticalAlign: 'middle' }}
													disabled={this.state.isReordering || index === 0}
													onClick={() => this.moveTraveler(index, -1)}
													aria-label="เลื่อนขึ้น"
												>
													<KeyboardArrowUpIcon style={{ fontSize: 20 }} />
												</button>
											)}
											{index === travelers.length - 1 ? null : (
												<button
													type="button"
													className="button is-small is-text"
													style={{ padding: 4, minWidth: 'auto', verticalAlign: 'middle' }}
													disabled={this.state.isReordering || index === travelers.length - 1}
													onClick={() => this.moveTraveler(index, 1)}
													aria-label="เลื่อนลง"
												>
													<KeyboardArrowDownIcon style={{ fontSize: 20 }} />
												</button>
											)}
										</td>
										<td>
											<button
												type="button"
												className="button is-small is-text"
												style={{ padding: 4, minWidth: 'auto', color: '#f14668' }}
												onClick={() => this.setState({ deleteConfirmId: data.id })}
												aria-label="ลบ"
											>
												<DeleteIcon style={{ fontSize: 20 }} />
											</button>
										</td>
									</tr>
								);
							})}
						</tbody>
					</table>
				</div>
				<ConfirmModal
					isActive={this.state.deleteConfirmId != null}
					closeModal={() => this.setState({ deleteConfirmId: null })}
					title="ยืนยันการลบ"
					message="คุณต้องการลบ Traveler นี้หรือไม่?"
					okLabel="ตกลง"
					cancelLabel="ยกเลิก"
					onConfirm={() => {
						this.deleteTraveler(this.state.deleteConfirmId);
					}}
				/>
			</div>
		);
	}
}
